export default __webpack_public_path__ + "static/media/french.e3677b41.svg";